import React from 'react';
import { Icon } from '@mdi/react';
import { mdiClose } from '@mdi/js';

import Search from './Search';
import { BackendUser } from '../../types';
import FlipProfilePhoto from '../../components/FlipProfilePhoto';
import Navigation from './Navigation';

interface WhoProps {
  users: Array<BackendUser>;
  user?: BackendUser;
  onChange: (user: BackendUser | undefined) => void;
  onNext: () => void;
}

export default function Who({
  user, users, onChange, onNext,
}: WhoProps) {
  const handleClearUser = () => {
    onChange(undefined);
  };

  return (
    <div>
      <h2>Who do you want to recognise?</h2>
      {
        user && (
          <div className="recognition-who">
            <div className="recognition-who-profile">
              <FlipProfilePhoto
                id={user.id}
                firstName={user.first_name}
                lastName={user.last_name}
              />
            </div>
            <div className="recognition-who-name">
              {`${user.first_name} ${user.last_name}`}
              <button type="button" aria-label="Close" onClick={handleClearUser}>
                <Icon path={mdiClose} size="12px" />
              </button>
            </div>
          </div>
        )
      }
      <Search users={users} onChange={onChange} />
      <Navigation
        next="Next"
        onNext={onNext}
        nextDisabled={!user}
      />
    </div>
  );
}
